import CashTamerHttpClient from './CashTamerHttpClient';
import CashTamerApiBase from './CashTamerApiBase';
import FundDashboardResponseModel from '@/models/funds/FundDashboardResponseModel';
import FundChangeNameRequestModel from '@/models/funds/FundChangeNameRequestModel';
import FundChangeNotesRequestModel from '@/models/funds/FundChangeNotesRequestModel';
import FundLogResponseModel from '@/models/funds/FundLogResponseModel';
import FundTransactionResponseModel from '@/models/funds/FundTransactionResponseModel';
import FundPaymentRequestModel from '@/models/funds/FundPaymentRequestModel';
import FundTransferRequestModel from '@/models/funds/FundTransferRequestModel';

export default class FundsApi extends CashTamerApiBase {
    public async getFundDashBoardAsync(bankAccountId: number, fundId: number, jwt: string): Promise<FundDashboardResponseModel> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId;
            const httpResponse = await httpClient.secureGetAsync(url, jwt);

            const fund = new FundDashboardResponseModel();
            fund.authorizedOperations = httpResponse.data.authorizedOperations;
            fund.fundId = httpResponse.data.fundId;
            fund.fundName = httpResponse.data.fundName;
            fund.bankAccountId = httpResponse.data.bankAccountId;
            fund.notes = httpResponse.data.notes;
            fund.isDepositFund = httpResponse.data.isDepositFund;
            fund.debits = httpResponse.data.debits;
            fund.credits = httpResponse.data.credits;
            fund.balance = httpResponse.data.balance;
            fund.createdBy = httpResponse.data.createdBy;
            fund.createdDateTimeUtc = httpResponse.data.createdDateTimeUtc;

            return fund;
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

    public async changeNameAsync(bankAccountId: number, fundId: number, jwt: string, request: FundChangeNameRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId + '/name';
            await httpClient.securePutAsync(url, request, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async changeNotesAsync(bankAccountId: number, fundId: number, jwt: string, request: FundChangeNotesRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId + '/notes';
            await httpClient.securePutAsync(url, request, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async deleteAsync(bankAccountId: number, fundId: number, jwt: string): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId;
            await httpClient.secureDeleteAsync(url, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async getLogsAsync(bankAccountId: number, fundId: number, jwt: string): Promise<FundLogResponseModel[]> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId + '/logs';
            const httpResponse = await httpClient.secureGetAsync(url, jwt);

            const values = new Array<FundLogResponseModel>();

            const len: number = httpResponse.data.length - 1;

            for ( let i = 0; i <= len; i++ ) {
                const value: FundLogResponseModel = new FundLogResponseModel();
                value.fieldName = httpResponse.data[i].fieldName;
                value.oldValue = httpResponse.data[i].oldValue;
                value.newValue = httpResponse.data[i].newValue;
                value.createdDateTimeUtc = httpResponse.data[i].createdDateTimeUtc;
                value.createdBy = httpResponse.data[i].createdBy;

                values.push(value);
            }

            return values;
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

    public async getTransactionsAsync(bankAccountId: number, fundId: number, jwt: string): Promise<FundTransactionResponseModel[]> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId + '/transactions';
            const httpResponse = await httpClient.secureGetAsync(url, jwt);

            const values = new Array<FundTransactionResponseModel>();

            const len: number = httpResponse.data.length - 1;

            for ( let i = 0; i <= len; i++ ) {
                const value: FundTransactionResponseModel = new FundTransactionResponseModel();
                value.transactionId = httpResponse.data[i].transactionId;
                value.debit = httpResponse.data[i].debit;
                value.credit = httpResponse.data[i].credit;
                value.transactionDate = httpResponse.data[i].transactionDate;
                value.transactionDescription = httpResponse.data[i].transactionDescription;

                values.push(value);
            }

            return values;
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

    public async paymentAsync(bankAccountId: number, fundId: number, jwt: string, request: FundPaymentRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId + '/payment';
            await httpClient.securePostAsync(url, request, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async transferAsync(bankAccountId: number, fundId: number, jwt: string, request: FundTransferRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/funds/' + fundId + '/transfer';
            await httpClient.securePostAsync(url, request, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }
}
